import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RoundButton from 'Components/UI/RoundButton';
import { DataValueMap } from 'Helpers/Testing';

const styles = () => ({
  root: {
  },
});

const JoinMeetingButton = ({
  className,
  classes,
  meetingResource,
  showMeetingLink,
}) => {
  const link = meetingResource.attr('link');
  const linkDisabled = link.length === 0;

  let joinMeetingLabel = 'Join Meeting';
  if (showMeetingLink) {
    const linkWithoutProtocol = link.replace('https://', '');
    joinMeetingLabel += `: ${linkWithoutProtocol}`;
  }

  return (
    <RoundButton
      className={classNames(classes.root, className)}
      color="secondary"
      component="a"
      disabled={linkDisabled}
      disableElevation
      fullWidth
      href={link}
      target="_blank"
      variant="contained"
      {...DataValueMap.init('join-meeting-button').build()}
    >
      {linkDisabled ? 'Meeting Link Not Found' : joinMeetingLabel}
    </RoundButton>
  );
};

JoinMeetingButton.defaultProps = {
  className: '',
  showMeetingLink: false,
};

JoinMeetingButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  meetingResource: PropTypes.object.isRequired,
  showMeetingLink: PropTypes.bool,
};

export default withStyles(styles)(JoinMeetingButton);
